<template>
   <common-form
      form-title="Access to Road"
      :back-route="this.backRoute"
      :errors="errors.non_field_errors"
      @submit="save"
      @save-and-continue="saveAndContinue"
      >
      <input-field v-model="form.strategic" placeholder="" type="multi-select" label="Strategic road" :errors="errors.strategic" one-line/>
      <input-field v-model="form.district" placeholder="" type="multi-select" label="District road" :errors="errors.district" one-line/>
      <input-field v-model="form.urban" placeholder="" type="multi-select" label="Urban road" :errors="errors.urban" one-line/>
      <input-field v-model="form.sub_urban" placeholder="" type="multi-select" label="Sub-urban  road" :errors="errors.sub_urban" one-line/>
      <input-field v-model="form.village" placeholder="" type="multi-select" label="Village road" :errors="errors.village" one-line/>
      <input-field v-model="form.other" placeholder="" type="multi-select" label="Other road" :errors="errors.other" one-line/>
   </common-form>
</template>

<script>
import CommonForm from '@/components/organisms/Home/Plan/Form'
import InputField from '@/components/molecules/Login/InputField';
import FormMixin from '@/mixins/planform';

export default {
   name: 'road-access-form',
   components: {
      InputField,
      CommonForm,
   },
   data()
   {
      const form = {
         strategic: [],
         district: [],
         urban: [],
         sub_urban: [],
         village: [],
         other: [],
      };

      return {
         form,
         errors: this.getDefaultErrors(form),
         backRoute: {name: 'edit-land-cover-info',params: {id: this.getPlanId()}},
         nextRoute: {name: 'stakeholders',params: {id: this.getPlanId()}},
      };
   },
   mixins: [FormMixin],
   computed: {
      url()
      {
         return `api/plan/${this.getPlanId()}/road-access`;
      },
      notificationTitle()
      {
         return 'Access to Road Information';
      },
      successMessage()
      {
         return 'Successfuly edited road access information'; 
      },
      errorMessage()
      {
         return "Editing road access information was unsuccessful";
      },
   },
}
</script>
